"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatYearlyUsageGeneric = exports.formatMonthlyUsageGeneric = exports.formatDailyUsageGeneric = exports.createMonthlyUsageEndpoint = exports.createDailyUsageEndpoint = exports.createHalfHourlyUsageEndpoint = void 0;
var createHalfHourlyUsageEndpoint = function (accountId, date) { return "/usage/api/half-hourly-local/".concat(accountId, "?date=").concat(date); };
exports.createHalfHourlyUsageEndpoint = createHalfHourlyUsageEndpoint;
var createDailyUsageEndpoint = function (accountId, date) { return "/usage/api/daily/".concat(accountId, "?date=").concat(date); };
exports.createDailyUsageEndpoint = createDailyUsageEndpoint;
var createMonthlyUsageEndpoint = function (accountId, date) { return "/usage/api/monthly/".concat(accountId, "?date=").concat(date); };
exports.createMonthlyUsageEndpoint = createMonthlyUsageEndpoint;
// can be removed when usage api returns proper UTC ISO format - ticket: USG-856
var convertUsageDateToUTC = function (date) {
    return date.includes('Z') ? date : date + 'Z';
};
var formatDailyUsageGeneric = function (data) {
    var electricity = data.electricity && data.electricity.data.length > 0
        ? data.electricity.data.map(function (usage) { return ({
            date: new Date(convertUsageDateToUTC(usage.interval.start)),
            consumption: usage.consumption,
            cost: null,
            hasData: null,
        }); })
        : null;
    var gas = data.gas && data.gas.data.length > 0
        ? data.gas.data.map(function (usage) { return ({
            date: new Date(convertUsageDateToUTC(usage.interval.start)),
            consumption: usage.consumption,
            cost: null,
            hasData: null,
        }); })
        : null;
    return { electricity: electricity, gas: gas };
};
exports.formatDailyUsageGeneric = formatDailyUsageGeneric;
var formatMonthlyUsageGeneric = function (data) {
    var electricity = data.electricity
        ? data.electricity.data.map(function (usage) { return ({
            date: new Date(usage.interval.start),
            consumption: usage.consumption,
            cost: usage.cost ? parseFloat(usage.cost.amount) : null,
            hasData: usage.hasHhData,
        }); })
        : null;
    var gas = data.gas
        ? data.gas.data.map(function (usage) { return ({
            date: new Date(usage.interval.start),
            consumption: usage.consumption,
            cost: usage.cost ? parseFloat(usage.cost.amount) : null,
            hasData: usage.hasHhData,
        }); })
        : null;
    return { electricity: electricity, gas: gas };
};
exports.formatMonthlyUsageGeneric = formatMonthlyUsageGeneric;
var formatYearlyUsageGeneric = function (data) {
    var electricity = data.electricity
        ? data.electricity.data.map(function (usage) { return ({
            date: new Date("".concat(usage.year, "/").concat(usage.month, "/01")),
            consumption: usage.consumption,
            cost: usage.cost ? parseFloat(usage.cost.amount) : null,
            hasData: true,
        }); })
        : null;
    var gas = data.gas
        ? data.gas.data.map(function (usage) { return ({
            date: new Date("".concat(usage.year, "/").concat(usage.month, "/01")),
            consumption: usage.consumption,
            cost: usage.cost ? parseFloat(usage.cost.amount) : null,
            hasData: true,
        }); })
        : null;
    return { electricity: electricity, gas: gas };
};
exports.formatYearlyUsageGeneric = formatYearlyUsageGeneric;
